import React from 'react'
import {Link, useRouteMatch} from 'react-router-dom'
import {useDispatch,useSelector} from 'react-redux'
import {setFavorites, deleteFavorites} from '../store/actions/pokemonAction'

export default function PokemonCard(props) {
    const {url} = useRouteMatch()
    const dispatch = useDispatch()
    const favorites = useSelector((state)=> state.pokemonReducer.favorites)
    let dataCard
    
    if(props.pokemons){
        if(props.pokemons.results) {
            dataCard = props.pokemons.results
        } else {
            dataCard = props.pokemons
        }
    }

    function doAddFavorite(event){
        const data = event.target.value
        const newObj ={
            id: data[0],
            name: data.substring(2)
        }
        dispatch(setFavorites(newObj))
    }

    function doDeleteFavorite(event){
        let pokemonName = event.target.value
        dispatch(deleteFavorites(pokemonName))
    }

    return (
        <div>
            <div className="row mt-3 mb-3 mr-3 ml-3">
                {dataCard && dataCard.map((pokemon,idx)=>{
                    return (
                        <div className="col-md-4" key={idx}>
                            <div className="card mb-2" style={{maxWidth: "20 rem"}} >
                                {pokemon.id ?
                                    <img src={`https://pokeres.bastionbot.org/images/pokemon/${pokemon.id}.png`} className="card-img-top" alt="pokemon" loading="lazy"></img> :
                                    <img src={`https://pokeres.bastionbot.org/images/pokemon/${idx+1}.png`} className="card-img-top" alt="pokemon" loading="lazy"></img>
                                }
                                <div className="card-body">
                                    <h5 className="card-title">{pokemon.name}</h5>
                                </div>
                                <div className="card-footer">
                                    {pokemon.id? 
                                        <Link data-testid="to-detail-btn" to={`${url}/${pokemon.id}`} className="btn btn-primary">Detail</Link> :
                                        <Link data-testid="to-detail-btn" to={`${url}/${idx+1}`} className="btn btn-primary">Detail</Link>
                                    }
                                    {favorites.find(cek => cek.name === pokemon.name) ?
                                        <button data-testid="remove-fav-btn" onClick={doDeleteFavorite} value={pokemon.name} className="btn btn-danger ml-2">Remove Favorite</button> :
                                        <button data-testid="add-fav-btn" onClick={doAddFavorite} value={[idx+1,pokemon.name]} className="btn btn-success ml-2">Add Favorite</button>
                                    }
                                </div>
                            </div>
                        </div>
                    )
                })}
                {!dataCard && <img style={styles.loading} src="https://thumbs.gfycat.com/FairSinfulCottontail-max-1mb.gif" alt="loading" />}
            </div>
        </div>
    )
}

const styles = {
    loading: {
        display: "block",
        margin: "0 auto"
    }
}

